import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { buildUserUrl } from '_core/utils';
import { usernameColor } from '_theme';

const Name = styled.a`
  font-size: ${(props) => props.size};
  color: ${(props) => props.color} !important;
  font-weight: ${(props) => (props.bold === 'true' || props.bold === true ? 'bold' : 'normal')};
  ${(props) => (props.shadow ? `text-shadow: 0 0 0.7em ${props.shadow};` : '')}
  ${(props) => (props.background ? `background: url('${props.background}');` : '')}
  cursor: pointer;
  position: relative;
  text-decoration: none;
  height: fit-content;

  &:hover {
    text-decoration: none;
  }
`;

class Username extends Component {
  render() {
    const route = buildUserUrl(this.props.user.userslug);
    const styles = this.props.user?.styles ?? {};
    return (
      <Link href={route.path} as={route.url} passHref>
        <Name
          color={styles.usernameColor ?? usernameColor}
          bold={styles.usernameBold ?? this.props.bold}
          shadow={styles.usernameShadow}
          background={styles.usernameEffectUrl}
          size={this.props.size}
          className={this.props.className}
          style={this.props.style}
        >
          {this.props.children === '[[global:guest]]' ? 'Deleted' : this.props.children}
        </Name>
      </Link>
    );
  }
}

Username.propTypes = {
  children: PropTypes.string,
  userId: PropTypes.number
};

Username.defaultProps = {
  size: '13px'
};

export default Username;
